import { ShapeTool } from ".";

const fabric = require("../fabric").fabric;

export class ArrowTool extends ShapeTool {

  buildShape(pointer, origX, origY) {
    let styleModule = this.imageEditor.getModule("style");

    let points = this.getPoints(pointer, origX, origY, styleModule.strokeSize)

    return new fabric.Polygon(points, {
      fill: styleModule.fillColor,
      stroke: styleModule.fillColor,
      strokeWidth: styleModule.strokeSize,
      transparentCorners: false,
      selectable: false
    });
  }

  mouseDrag(arrow, pointer, origX, origY) {
    let styleModule = this.imageEditor.getModule("style");
    let points = this.getPoints(pointer, origX, origY, styleModule.strokeSize);

    let left = 0;
    let top = 0;
    let width = 100;
    let height = 100;
    for (const point of points) {
      //left = Math.min(point.x, left);
      //top = Math.min(point.y, top);
      //width = Math.max(point.x, width);
      //height = Math.max(point.y, height);
    }

    left += origX;
    top += origY;

    //console.log(parseInt(left), parseInt(top), parseInt(width), parseInt(height));
    
    //this.translatePoints(points, -Math.min(left, 0), -Math.min(top, 0));

    arrow.set({
      points: points
    });
    
    let calcDim = arrow._calcDimensions();
    
    let sizeoffset = styleModule.strokeSize;

    arrow.width = calcDim.width + (sizeoffset*2);
    arrow.height = calcDim.height + (sizeoffset*2);

    arrow.set({
      left: calcDim.left + origX - sizeoffset,
      top: calcDim.top + origY - sizeoffset,
      pathOffset: {
        x: calcDim.left - sizeoffset + arrow.width / 2,
        y: calcDim.top - sizeoffset + arrow.height / 2
      }
    });

    arrow.setCoords();
  }

  getPoints(pointer, origX, origY, width) {

    let dist = new fabric.Point(pointer.x, pointer.y).distanceFrom(new fabric.Point(origX, origY));

    width /= 4;

    let points = [
      {x: 0, y: width},
      {x: dist - width, y: width},
      {x: dist - width, y: width + width/2},
      {x: dist, y: 0},
      {x: dist - width, y: -width - width/2},
      {x: dist - width, y: -width},
      {x: 0, y: -width},
    ];

    let invert = pointer.x < origX;
    let a = pointer.y-origY;
    let b = pointer.x-origX;
    let c = Math.sqrt(Math.pow(b, 2) + Math.pow(a, 2));
    let ang = Math.asin(a/c);

    if(invert){
      ang = Math.PI - ang
    }

    this.rotatePoints(points, ang);

    return points;
  }

  translatePoints(points, x, y) {
    for (const point of points) {
      point.x += x;
      point.y += y;
    }
  }

  rotatePoints(points, angle) {
    for (const point of points) {
      let newx = Math.cos(angle) * point.x - Math.sin(angle) * point.y;
      let newy = Math.sin(angle) * point.x + Math.cos(angle) * point.y;
      point.x = newx;
      point.y = newy;
    }
  }

}